import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../../app_constants";

export const SET_LOADING = "sagas/attendance/average_number_of_visits_per_client/SET_LOADING";
export const SET_CHART_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_CHART_LOADING";
export const SET_UPDATES_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_UPDATES_LOADING";
export const SET_PRIMARY_CATEGORIES_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_PRIMARY_CATEGORIES_LOADING";
export const SET_SECONDARY_CATEGORIES_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_SECONDARY_CATEGORIES_LOADING";
export const SET_PRICING_OPTIONS_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_PRICING_OPTIONS_LOADING";
export const SET_FILTERS_LOADING =
  "sagas/attendance/average_number_of_visits_per_client/SET_FILTERS_LOADING";
export const SET_FILTERS_DIRTY =
  "sagas/attendance/average_number_of_visits_per_client/SET_FILTERS_DIRTY";
export const FETCH_CURRENT_USER =
  "sagas/attendance/average_number_of_visits_per_client/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/attendance/average_number_of_visits_per_client/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_DATA_SUCCESS =
  "sagas/attendance/average_number_of_visits_per_client/FETCH_CHART_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS =
  "sagas/attendance/average_number_of_visits_per_client/FETCH_FILTERS_SUCCESS";
export const UPDATE_CHART = "sagas/attendance/average_number_of_visits_per_client/UPDATE_CHART";
const UPDATE_TABLE_VIEW = "sagas/attendance/average_number_of_visits_per_client/UPDATE_TABLE_VIEW";
export const UPDATE_TABLE_VIEW_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_TABLE_VIEW_SELECTED";
export const SET_DATES = "sagas/attendance/average_number_of_visits_per_client/SET_DATES";
export const UPDATE_DATES = "sagas/attendance/average_number_of_visits_per_client/UPDATE_DATES";
const UPDATE_PRIMARY_CATEGORY =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_PRIMARY_CATEGORY";
export const UPDATE_PRIMARY_CATEGORY_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_PRIMARY_CATEGORY_SELECTED";
const UPDATE_SECONDARY_CATEGORY =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_SECONDARY_CATEGORY";
export const UPDATE_SECONDARY_CATEGORY_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_SECONDARY_CATEGORY_SELECTED";
const UPDATE_PRICING_OPTION =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_PRICING_OPTION";
export const UPDATE_PRICING_OPTION_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_PRICING_OPTION_SELECTED";
export const UPDATE_TYPE_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_TYPE_SELECTED";
export const UPDATE_MEMBERSHIP_TYPES_OPTION_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_MEMBERSHIP_TYPES_OPTION_SELECTED";
const RESET_FILTER = "sagas/attendance/average_number_of_visits_per_client/RESET_FILTER";
export const RESET_FILTER_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/RESET_FILTER_SELECTED";
export const UPDATE_CUSTOM_RANGE =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_CUSTOM_RANGE";
export const UPDATE_GROUP_BY =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_GROUP_BY";
export const UPDATE_ONLY_MEMBERSHIPS =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_ONLY_MEMBERSHIPS";
export const UPDATE_ONLY_MEMBERSHIPS_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_ONLY_MEMBERSHIPS_SELECTED";
export const UPDATE_TYPE_OPTION =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_TYPE_OPTION";
export const UPDATE_MEMBERSHIP_TYPES =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_MEMBERSHIP_TYPES";
const UPDATE_AVERAGE_BREAKDOWN =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_AVERAGE_BREAKDOWN";
export const UPDATE_AVERAGE_BREAKDOWN_SELECTED =
  "sagas/attendance/average_number_of_visits_per_client/UPDATE_AVERAGE_BREAKDOWN_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updatePrimaryCategory: createAction(UPDATE_PRIMARY_CATEGORY),
  updateSecondaryCategory: createAction(UPDATE_SECONDARY_CATEGORY),
  updatePricingOption: createAction(UPDATE_PRICING_OPTION),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateGroupBy: createAction(UPDATE_GROUP_BY),
  updateTypeOption: createAction(UPDATE_TYPE_OPTION),
  updateMembershipTypes: createAction(UPDATE_MEMBERSHIP_TYPES),
  resetFilters: createAction(RESET_FILTER),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updateOnlyMemberships: createAction(UPDATE_ONLY_MEMBERSHIPS),
  updateAverageBreakdown: createAction(UPDATE_AVERAGE_BREAKDOWN)
};

export default function* watchNumberOfVisits() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_PRIMARY_CATEGORY, updatePrimaryCategory);
  yield takeLatest(UPDATE_SECONDARY_CATEGORY, updateSecondaryCategory);
  yield takeLatest(UPDATE_PRICING_OPTION, updatePricingOption);
  yield takeLatest(UPDATE_TYPE_OPTION, updateTypeOption);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_ONLY_MEMBERSHIPS, updateOnlyMemberships);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_AVERAGE_BREAKDOWN, updateAverageBreakdown);
}

function* checkForActiveToggle() {
  const membershipState = yield select(
    (state) => state.averageNumberOfVisitsPerClient.filters.toggles.showMembershipsOnly.default
  );
  if (membershipState) yield getFiltersByMemberships(membershipState);
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });
  yield checkForActiveToggle();
  try {
    yield fetchFilters();
    yield fetchChartData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  yield put({ type: SET_CHART_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChartData();
    yield put({ type: SET_CHART_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updatePrimaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload });
  yield updateFilters("primary_categories", payload);
  yield getOnlyMembershipsByFilters();
}

function* updateSecondaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload });
  yield updateFilters("secondary_categories", payload);
  yield getOnlyMembershipsByFilters();
}

function* updatePricingOption({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload });
  yield updateFilters("pricing_options", payload);
  yield getOnlyMembershipsByFilters();
}

function* updateTypeOption({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_TYPE_SELECTED, payload });
  yield fetchFilters();
}

function* getOnlyMembershipsByFilters() {
  const membershipState = yield select(
    (state) => state.averageNumberOfVisitsPerClient.filters.toggles.showMembershipsOnly.default
  );
  const { primary_categories, secondary_categories, pricing_options } = yield select(
    (state) => state.averageNumberOfVisitsPerClient.selectedFilters
  );
  const combinedCategories = [...primary_categories, ...secondary_categories, ...pricing_options];
  if (!membershipState) {
    let isMembershipCategory = combinedCategories.every(
      (category) => category.memberships === true
    );
    yield put({ type: UPDATE_ONLY_MEMBERSHIPS_SELECTED, payload: isMembershipCategory });
  }
}

function* updateOnlyMemberships({ payload }) {
  yield put({ type: UPDATE_ONLY_MEMBERSHIPS_SELECTED, payload });
  yield getFiltersByMemberships();
  yield updateData();
}

function* updateAverageBreakdown({ payload }) {
  yield put({ type: UPDATE_AVERAGE_BREAKDOWN_SELECTED, payload });
  yield put({ type: SET_CHART_LOADING, payload: true });
  try {
    yield fetchChartData();
    yield put({ type: SET_CHART_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getFiltersByMemberships() {
  const { primary_categories, secondary_categories, pricing_options } = yield select(
    (state) => state.averageNumberOfVisitsPerClient.filters
  );
  const combinedFilters = { primary_categories, secondary_categories, pricing_options };
  const membershipState = yield select(
    (state) => state.averageNumberOfVisitsPerClient.selectedFilters.only_memberships
  );
  let filters = {};
  if (membershipState) {
    for (let filterKey in combinedFilters) {
      let options = combinedFilters[filterKey];
      filters[filterKey] = options.filter((option) => option.memberships === true);
    }
    yield updateTopFilters(filters);
  } else {
    yield updateTopFilters(combinedFilters);
  }
}

function* updateTopFilters(filters) {
  yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload: filters.primary_categories });
  yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload: filters.secondary_categories });
  yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: filters.pricing_options });
}

function* setDates() {
  const endDate = yield select(
    (state) => state.averageNumberOfVisitsPerClient.currentUser.calendarEndDate
  );
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

export function* fetchChartData() {
  const {
    organization_id,
    short_url,
    startDate,
    endDate,
    table_view,
    primary_categories,
    secondary_categories,
    pricing_options,
    group_by,
    membership_types,
    type,
    average_breakdown
  } = yield getApiParams();

  const paramsByType =
    type === "category"
      ? {
          primary_categories,
          secondary_categories,
          pricing_options,
          group_by
        }
      : { membership_types };

  let params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    table_view,
    type,
    average_breakdown,
    ...paramsByType
  };

  let url = queryParams.apiVersion + `pages/attendance/average_numbers_of_visits_per_client_chart`;

  try {
    let { data } = yield call(axios.post, url, params);
    yield put({ type: FETCH_CHART_DATA_SUCCESS, payload: data });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield setDates();
  try {
    yield fetchFilters();
    yield checkForActiveToggle();
    yield fetchChartData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let params = yield select((state) => {
    const {
      selectedRequestDates: { startDate, endDate },
      selectedFilters: {
        table_view,
        primary_categories = [],
        secondary_categories = [],
        pricing_options = [],
        group_by,
        membership_types,
        type,
        average_breakdown
      }
    } = state.averageNumberOfVisitsPerClient;

    return {
      startDate,
      endDate,
      table_view,
      primary_categories:
        primary_categories.length > 0 ? primary_categories.map(({ id }) => id).join(",") : "-1",
      secondary_categories:
        secondary_categories.length > 0 ? secondary_categories.map(({ id }) => id).join(",") : "-1",
      pricing_options:
        pricing_options.length > 0 ? pricing_options.map(({ id }) => id).join(",") : "-1",
      group_by: group_by.id,
      membership_types: membership_types.map(({ id }) => id).join(","),
      type: type.id,
      average_breakdown: average_breakdown.id
    };
  });

  return { organization_id, short_url, ...params };
}

export function* fetchFilters() {
  const { organization_id, short_url, startDate, endDate, type } = yield getApiParams();

  const params = {
    organization_id,
    short_url,
    type,
    end_date: endDate,
    start_date: startDate
  };

  let url =
    queryParams.apiVersion + "pages/attendance/average_numbers_of_visits_per_client_chart/filters";

  try {
    yield put({ type: SET_FILTERS_LOADING, payload: true });
    const { data } = yield call(axios.post, url, params);
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: data.filters });
    const {
      primary_categories = [],
      secondary_categories = [],
      pricing_options = [],
      membership_types = []
    } = data.filters || {};
    yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload: primary_categories });
    yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload: secondary_categories });
    yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: pricing_options });
    yield put({ type: UPDATE_MEMBERSHIP_TYPES_OPTION_SELECTED, payload: membership_types });
    yield put({ type: SET_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield fetchChartData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateFilters(name, payload) {
  const values = payload.map((p) => p.id).join(",");
  if (name === "primary_categories") {
    yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: true });
    yield getRevenueCategories(values, name);
  }
  if (name === "secondary_categories") {
    yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: true });
    yield getRevenueCategories(values, name);
  }
  if (name === "pricing_options") {
    yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: true });
    yield getRevenueCategories(values, name);
  }
}

function* getRevenueCategories(categoryValues, name) {
  const { organization_id, short_url, startDate, endDate } = yield getApiParams();

  const params = {
    [name]: categoryValues,
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate
  };

  let url =
    queryParams.apiVersion +
    "pages/attendance/average_numbers_of_visits_per_client_chart/get_revenue_categories";
  try {
    let { data } = yield call(axios.post, url, params);
    if (name === "pricing_options") {
      yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: false });
      yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: false });
      yield put({
        type: UPDATE_PRIMARY_CATEGORY_SELECTED,
        payload: data.primary_categories
      });
      yield put({
        type: UPDATE_SECONDARY_CATEGORY_SELECTED,
        payload: data.secondary_categories
      });
    }
    if (name === "primary_categories") {
      yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: false });
      yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: false });
      yield put({
        type: UPDATE_SECONDARY_CATEGORY_SELECTED,
        payload: data.secondary_categories
      });
      yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: data.pricing_options });
    }
    if (name === "secondary_categories") {
      yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: false });
      yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: false });
      yield put({
        type: UPDATE_PRIMARY_CATEGORY_SELECTED,
        payload: data.primary_categories
      });
      yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: data.pricing_options });
    }
  } catch (error) {
    console.error(error);
  }
}
